import { apiWrapper } from "@ch/api";
import { NotificationControllerService } from "@ch/generated";
import { handleError } from "@ch/helpers/utils/handleError";

interface TTrackPushNotification {
  id: string;
  isClicked?: boolean;
  isDelivered?: boolean;
}

const trackPushNotification = async ({
  id,
  isClicked,
  isDelivered,
}: TTrackPushNotification) => {
  try {
    const response = await apiWrapper(() =>
      NotificationControllerService.notificationControllerUpdateById({
        id,
        requestBody: {
          isClicked,
          isDelivered,
        },
      }),
    );

    return response;
  } catch (error) {
    handleError(error);
    return undefined;
  }
};

export default trackPushNotification;
